import {
    Component,
    OnInit,
    Input,
    ChangeDetectorRef,
    AfterViewInit
  } from "@angular/core";
  
  import {
    PaymentMethodInfo,
    CCPaymentInfo,
    IBANPaymentInfo,
    PaymentMethodTypes,
    CCTypes
  } from '../../models/sales';
  
  import { ADPResourceService as ResourceService } from "digital-core";
  
  @Component({
    selector: "gsp-payment-info-name",
    templateUrl: "./payment-info-name.component.html",
    styleUrls: ["./payment-info-name.component.css"]
  })
  export class PaymentInfoNameComponent implements OnInit, AfterViewInit {
    paymentInfo: PaymentMethodInfo;
  
    ccPaymentMethod: CCPaymentInfo;
    currentCCType: CCTypes;
  
    ibanPaymentMethod: IBANPaymentInfo;
    last4CardNumber: string;
    paymentMethodType: any = PaymentMethodTypes;
    ccpaymentType: any = CCTypes;
    displayCCForm = false;
    isOTPFlow : boolean = false;
  
    constructor(
      public resourcesService: ResourceService,
      private cd: ChangeDetectorRef
    ) {}
  
    ngOnInit() {
      this.displayCCForm = JSON.parse(this.resourcesService.getPortalSetting("Show_CCPayment_Form").Value);
      this.isOTPFlow = JSON.parse(this.resourcesService.getPortalSetting("IsSMSEnabled").Value);
    }
  
    ngAfterViewInit() {
       this.cd.detectChanges();
    }
  
    refresh(paymentInfo: PaymentMethodInfo) {
      this.paymentInfo = paymentInfo;
      this.last4CardNumber = this.getLast4();
      this.currentCCType = this.getCCType();
    }
  
    getLast4() {
      let carNumber = "";
      if (!this.paymentInfo) {
        return "";
      }
      switch (this.paymentInfo.PaymentMethodType) {
        case PaymentMethodTypes.CreditCard:
          this.ccPaymentMethod = this.paymentInfo as CCPaymentInfo;
          carNumber = this.isOTPFlow ? "" : this.ccPaymentMethod.CreditCardNumber.replace(" ", "");
          return carNumber.substring(carNumber.length - 4, carNumber.length);        
        case PaymentMethodTypes.IBAN:
          this.ibanPaymentMethod = this.paymentInfo as IBANPaymentInfo;
          carNumber = this.ibanPaymentMethod.IBANNumber.replace(" ", "");
          return carNumber.substring(carNumber.length - 4, carNumber.length);
      }
      return "";
    }
    getCCType() {
      if (!this.ccPaymentMethod || this.isOTPFlow) {
        return CCTypes.None;
      }
  
      let regMatch = this.ccPaymentMethod.CreditCardNumber.match(/\b4/);
  
      if (regMatch && regMatch.length > 0) {
        return CCTypes.Visa;
      }
      regMatch = this.ccPaymentMethod.CreditCardNumber.match(
        /^5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720$/
      );
      if (regMatch && regMatch.length > 0) {
        return CCTypes.MasterCard;
      }
    }
  
   
  }
  